import { App, SortDirection, SortOption } from '@piwikpro/apps-crate';
import {
  createAction,
  handleActions,
} from 'redux-actions';

export interface AppsListState {
  isLoading: boolean
  failed: boolean
  apps: App[]
  total: number
  totalWithoutFilters: number
  filters: {
    search: string
    sort: SortOption
  }
}

interface AppsListPayload {
  offset: number
  data: App[]
  meta: {
    total: number
  }
  location: {
    pathname: string
  }
}

const isUnderAppsRoute = new RegExp('/apps(.*)');
const isUnderLicenseRoute = new RegExp('/subscription(.*)');
const initialState: AppsListState = {
  isLoading: true,
  failed: false,
  apps: [],
  total: 0,
  // total changes during search manipulation
  // we need non-filtered global value to handle license apps limit
  totalWithoutFilters: 0,
  filters: {
    search: '',
    sort: {
      by: 'name',
      direction: SortDirection.ASC,
    },
  },
};

export const configureAppsFetch = createAction(
  '@platform/event/apps/configureFetch',
  payload => payload,
);

const reducer = handleActions<AppsListState, AppsListPayload>({
  '@platform/query/apps/list/init': (state, { payload }) => ({
    ...state,
    isLoading: true,
    apps: !payload.offset ? initialState.apps : [...state.apps],
    total: !payload.offset ? initialState.total : state.total,
    filters: {
      ...state.filters,
      ...payload,
    },
  }),
  '@platform/query/apps/list/success': (state, { payload }) => {
    const apps = [
      ...state.apps,
      ...payload.data,
    ];

    return {
      ...state,
      apps: Array.from(new Set(apps.map(app => app.id)))
        .map(id => apps.find(app => app.id === id)) as App[],
      total: state.total > 0 ? state.total : payload.meta.total,
      totalWithoutFilters: state.filters.search === '' ? payload.meta.total : state.totalWithoutFilters,
      isLoading: false,
      failed: false,
    };
  },
  '@platform/query/apps/list/failed': state => ({
    ...state,
    isLoading: false,
    failed: true,
    total: 0,
  }),
  [configureAppsFetch.toString()]: (state, { payload }) => ({
    ...state,
    filters: {
      ...state.filters,
      ...payload,
    },
  }),
  '@platform/command/apps/create/success': state => ({
    ...state,
    totalWithoutFilters: state.totalWithoutFilters + 1,
  }),
  '@platform/command/apps/delete/success': state => ({
    ...state,
    totalWithoutFilters: state.totalWithoutFilters - 1,
  }),
  '@@router/LOCATION_CHANGE': (state, { payload }) => {
    if (
      !(isUnderAppsRoute.test(payload.location.pathname)
      // license view fetches apps total
      || isUnderLicenseRoute.test(payload.location.pathname)
      )) {
      return initialState;
    }

    return {
      ...state,
    };
  },
}, initialState);

export default reducer;
